import { wrapClassNames } from '@ui/utils/tailwind';
import type { SVGProps } from 'react';
import { forwardRef } from 'react';

interface SortArrowProps extends Omit<SVGProps<SVGSVGElement>, 'direction'> {
  active?: never;
  activeClassName?: string;
  direction?: 'asc' | 'desc';
  tw?: never;
}

export const Arrow = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>((props, ref) => (
  <svg ref={ref} {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g fill="currentColor">
      <path
        d="M23.292 10.24a1.413 1.413 0 0 0-1.994.127l-7.448 8.464a.251.251 0 0 1-.438-.166V1.413a1.412 1.412 0 1 0-2.824 0v17.252a.251.251 0 0 1-.438.166L2.7 10.367a1.413 1.413 0 1 0-2.119 1.867L10.233 23.2a2.352 2.352 0 0 0 3.534 0l9.652-10.967a1.412 1.412 0 0 0-.127-1.993z"
        fill="currentColor"
      />
    </g>
  </svg>
));

export const LinkArrow = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>((props, ref) => (
  <svg ref={ref} {...props} fill="currentColor" viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg">
    <path d="M537.891 142.444l-.05 182.076C104.665 327.962 19.215 649.915 3.568 810.72l-1.381 16.04C-1.151 871.342.326 883.555.326 883.555c.19 7.914 5.609 14.373 12.585 16.057l3.601.429 5.293-.704c5.856-1.462 12.131-5.069 16.421-9.579l2.808-3.532s19.018-30.02 33.633-49.427c179.668-238.587 418.198-230.856 463.238-227.047l-.011 178.237c0 17.874 12.398 23.753 26.966 13.635l447.63-310.921c14.893-10.345 15.548-26.969.706-37.678L564.153 129.028c-14.503-10.464-26.26-4.112-26.26 13.418z" />
  </svg>
));

export const SortArrow = forwardRef<SVGSVGElement, SortArrowProps>(
  ({ direction, activeClassName = '', className = '', ...props }, ref) => (
    <svg
      ref={ref}
      {...props}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      className={wrapClassNames(`shrink-0 ${className}`)}
    >
      <g fill="currentColor" className={direction === 'asc' ? activeClassName : ''}>
        <path d="M3.616 9.609a1.252 1.252 0 0 0 1.768 0l6.439-6.423a.252.252 0 0 1 .354 0l6.439 6.423a1.248 1.248 0 0 0 1.768-1.763l-7.5-7.481a1.252 1.252 0 0 0-1.768 0l-7.5 7.481a1.245 1.245 0 0 0 0 1.763z" />
      </g>
      <g fill="currentColor" className={direction === 'desc' ? activeClassName : ''}>
        <path d="M20.384 14.391a1.252 1.252 0 0 0-1.768 0l-6.439 6.423a.252.252 0 0 1-.354 0l-6.439-6.423a1.248 1.248 0 0 0-1.768 1.763l7.5 7.481a1.253 1.253 0 0 0 1.768 0l7.5-7.481a1.245 1.245 0 0 0 0-1.763z" />
      </g>
    </svg>
  )
);
